import { useState, useEffect } from "react";
import { API_URL } from "../../shared/constant";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const LoginComponent = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (email && password) {
      setLoading(true);
      axios.post(API_URL.LOGIN_URL, { email: email, password: password }).then(
        (res) => {
          if (res.data.access_token) {
            sessionStorage.setItem("access_token", res.data.access_token);
            sessionStorage.setItem("user_name", res.data.user_name);
            sessionStorage.setItem("logo", res.data.logo);
            navigate("/admin/dashboard", { replace: true });
          } else {
            toast.error("Invalid Username or Password", {
              autoClose: 3000,
              position: "top-center",
            });
          }
          setLoading(false);
        }, () => {
          setLoading(false);
          toast.error("Something went wrong..", {
            autoClose: 3000,
            position: "top-center",
          });
        }
      );
    } else {
      toast.error("Please enter valid username and password", {
        autoClose: 3000,
        position: "top-center",
      });
    }
  };

  useEffect(() => {
    const access_token = sessionStorage.getItem("access_token");
    if (access_token) {
      navigate("admin/dashboard", { replace: true });
    }
  }, []);

  return (
    <div className="main-wrapper login-body">
      <div className="login-wrapper">
        <div className="container">
          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px"
                  }}
                >
                  <img
                    src={"/assets/img/logo.png"}
                    className="img-fluid logo"
                    alt="1"
                  />
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-control-label" style={{ fontWeight: "400" }}>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-control-label" style={{ fontWeight: "400" }}>Password</label>
                    <div className="pass-group">
                      <input
                        type={togglePassword ? "text" : "password"}
                        className="form-control pass-input"
                        autoComplete="false"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span className={`fas ${togglePassword ? 'fa-eye' : 'fa-eye-slash'} toggle-password`} onClick={() => { setTogglePassword(!togglePassword) }}></span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn btn-lg btn-block btn-primary"
                      type="submit"
                      style={{ padding: "10px 20px" }}
                    >
                      {isLoading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                      ) : null}
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
export default LoginComponent;
